import { FILTER_PREFIX } from '@/constants'

export const getKeyWidthPrefix = (value, prefix) =>
    prefix + value.charAt(0).toUpperCase() + value.slice(1)

export const getValueWithRemovedPrefix = (value, prefix) => {
    const replacedValue = value.replace(prefix, '')

    return replacedValue.charAt(0).toLowerCase() + replacedValue.slice(1)
}

export const getFiltersFromSearchParams = (
    object,
    prefix = FILTER_PREFIX,
    ) =>
    Object.keys(object)
        .map(key => ({
            id: key,
            value: object[key],
        }))
        .filter(item => item.id.includes(prefix)) || []

export const getTransformedFilterToObjectAndType = (
    filters,
    instruction,
) =>
    filters.reduce(
        (acc, item) => ({
            ...acc,
            [item.id]: transformTypeByInstruction(item, instruction),
        }),
        {},
    )

const transformTypeByInstruction = (
    item,
    instruction,
) => {
    switch (instruction[item.id]) {
        case 'number':
            return Number(item.value)
        case 'string':
            return String(item.value)
        case 'boolean':
            return item.value.length ? item.value.toLowerCase() === 'true' : undefined
        // TODO: доработать вариант с массивом, пока шляпная затычка
        case 'arrayOfString':
            return item.value.split(',').map(value => String(value.trim()))
        case 'arrayOfNumber':
            return item.value.split(',').map(value => Number(value.trim()))
        case 'array':
            return [Number(item.value)]
    }
}

export function setFilterParamsToSearchParams(
    filterList,
    searchParams,
) {
    filterList.forEach(item => {
        if (item.value) {
            searchParams.set(
                getKeyWidthPrefix(item.id, FILTER_PREFIX),
                String(item.value),
            )
        } else {
            searchParams.delete(getKeyWidthPrefix(item.id, FILTER_PREFIX))
        }
    })
}
